module.exports = "/_next/static/images/rahul2-29f8b18f1f82199fc771c60e36c04dd8.jpeg";